/* Match explicit promotion entries and actual Shopify coupon cookies.
   Do not infer referral from analytics cookies or old broad storage flags. */
(() => {
  const cfg=window.HTSPublicOffer || {};
  const valid=cfg.codes || [];
  const known=value=>valid.find(c=>c.toLowerCase()===String(value||'').toLowerCase());
  function detect(){
    const params=new URLSearchParams(location.search);
    let code=known(params.get('discount'));
    const match=document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if(!code && match){try{code=known(decodeURIComponent(match[1]));}catch(_){}}
    if(!code && params.get('promo')?.toLowerCase()===String(cfg.promoToken||'happy15').toLowerCase()) code=known('Happy15')||known(cfg.code);
    if(!code && params.get('ref')) code=known(params.get('ref'))||known(cfg.code);
    // /happy15 -> /discount/Happy15 -> /?welcome=1. The code cookie is authoritative.
    if(!code){try{code=known(sessionStorage.getItem('hts_referral_code_v2'));}catch(_){}}
    if(code){
      try{sessionStorage.setItem('hts_referral_code_v2',code);}catch(_){}
      window.HTSReferralCode=code;
      document.documentElement.classList.add('hts-offer-active');
      return code;
    }
    return null;
  }
  window.HTSDetectReferral=detect;
  detect();
})();
